<div class="custom-modal">
  <div class="bloco-unico">
    <h3 class="uppercase">Dados da guia</h3>
    <hr />
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Natureza</th>
            <th>Qtde/Vol</th>
            <th>Peso (Kg)</th>
            <th>Peso Arquivo Original</th>
            <th>Peso Cubado</th>
            <th>Peso Cubado Original</th>
            <th>Valor Original</th>
            <th>Lacre</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ pedido?.pedidoItem?.natMerc }}</td>
            <td>{{ pedido?.pedidoItem?.qtde | number }}</td>
            <td>{{ pedido?.pedidoItem?.peso | number }}</td>
            <td>{{ pedido?.pedidoItem?.pesoArqOrig | number }}</td>
            <td>{{ pedido?.pedidoItem?.peso_cub | number }}</td>
            <td>{{ pedido?.pedidoItem?.pesoCubOrig | number }}</td>
            <td>{{ pedido?.pedidoItem?.valor | currency: "BRL" }}</td>
            <td>{{ pedido?.pedidoItem?.numLacre | number }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
